
import { useRouter } from "vue-router";
import {
  computed,
  defineComponent,
  watchEffect
} from "vue";
import { useAPIData } from "@/hooks/doc";
import { useStore } from "vuex";
import { IGlobalState } from "@/store";

export default defineComponent({
  props: {
    groupid: {
      type: String,
      default: "",
    },
    groupname: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const router = useRouter();
    const store = useStore<IGlobalState>();
    const apis = computed(() => store.state.doc.apis);
    /**
     * 获取接口列表
     */
    const getAPIData = async () => {
      await useAPIData(store, props.groupid);
    };
    watchEffect(getAPIData);
    /**
     * 查看接口详情
     */
    function lookApiInfo(id: string) {
      router.push({
        name: "interfacedetail",
        query: router.currentRoute.value.query,
        params: { groupid: props.groupid, groupname: props.groupname, apiId: id }
      });
    }
    /**
     * 根据环境返回不同的版本号
     */
    function getVersion(value: string) {
      let version = value;
      if (process.env.VUE_APP_FORM_KEY === 'gzopen') {
        version = process.env.VUE_APP_MAX_VERSION + '.0'
      }
      return version;
    }
    return {
      apis,
      lookApiInfo,
      getVersion
    };
  },
});
